module.exports = __webpack_public_path__ + "img/download.1391494d.svg";